//React
import React, { useState } from "react";
import PropTypes from "prop-types";
import Loader from "../../components/misc/loader";
//CSS
import "./inputs.scss";

function Button({ text, type, onClick, style, disabled, loaded, size = "md" }) {
	const wrapperClasses = [
		"input-wrapper",
		disabled ? "disabled" : "enabled",
		style,
		loaded ? "loading" : "default",
	];
	return (
		<div className={wrapperClasses.join(" ")}>
			<div className="input--inner">
				<button
					type={type}
					disabled={disabled}
					className={`${style} button--${size}`}
					onClick={() => onClick ? onClick() : null}
				>
					<span className="button-text">{text}</span>
					{loaded ? <Loader size="sm" /> : ""}
				</button>
			</div>
		</div>
	);
}

Button.propTypes = {
	text: PropTypes.string.isRequired,
	type: PropTypes.oneOf(["button", "submit"]).isRequired,
	style: PropTypes.oneOf(["dark", "light", "danger", "forgotPass", "btn-simple"]).isRequired,
	disabled: PropTypes.bool.isRequired,
	onClick: PropTypes.func,
	loaded: PropTypes.bool.isRequired,
	// "md" is the 48px form-action button. "sm" is the 36px in-page action that sits
	// level with card-header controls such as the Console's View All link.
	size: PropTypes.oneOf(["sm", "md"]),
};

export default Button;
